<template>


  <div>
    <div class="flex justify-center mb-4">
      <a-select placeholder="Filter a report" v-model:value="selectedReport" :options="options" style="width: 200px">
      </a-select>
    </div>
    <div class="flex justify-center mb-4">
      <div class="flex">
        <a-pagination v-model:current="current" :total="totalItem"  :show-total="total => `Total ${total} items`"/>
      </div>
    </div>
    <a-spin :spinning="submitting">
      <ul role="list" class="mb-4  grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        <li v-for="item in responses" class="mb-4">
          <response-card :card="item"></response-card>
        </li>
      </ul>
    </a-spin>

    <div class="flex justify-center mb-4">
      <div class="flex">
        <a-pagination v-model:current="current" :total="totalItem"  :show-total="total => `Total ${total} items`"/>
      </div>
    </div>
  </div>


</template>

<script>

import {defineComponent, onMounted, ref, watch} from "vue";
import ResponseCard from "@/Pages/StandUp/Response/ResponseCard";

export default defineComponent({
  props: [],
  emits: [],
  components: {
    ResponseCard

  },
  setup() {
    const current = ref(1);
    const responses = ref([]);
    const submitting = ref(false);
    const options = ref([]);
    const selectedReport = ref(null);
    const totalItem = ref(1);
    watch(current, () => {
      fetchItems(current.value, selectedReport.value);
    });
    watch(selectedReport, () => {
      current.value = 1;
      fetchItems(current.value, selectedReport.value);
    });
    onMounted(() => {
      fetchItems(current.value, selectedReport.value);
    })

    function fetchItems(current, reportId = null) {
      console.log('chjeck')
      submitting.value = true;
      axios
          .get(route("stand-up.response", {page: current, report_id: reportId}))
          .then((response) => {
            responses.value = response.data.data;
            submitting.value = false;
            options.value = response.data.reports;
            totalItem.value =response.data.total_item;
          })
          .catch((error) => {
            submitting.value = false;
          });
    }

    return {
      totalItem,
      current,
      responses,
      submitting,
      selectedReport,
      options
    }
  },
});
</script>
